import React from 'react';
import { responsiveFont, responsivePaddingHorizontal, responsivePaddingVertical, responsiveImageSize, HorizontalPadding } from '../../common/responsive.utils';
import useMediaQuery from '@mui/material/useMediaQuery';
import BackgroundImageWeb from '../../../assets/images/sitter/web/condition_background.png'
import BackgroundImageMobile from '../../../assets/images/sitter/mobile/condition_background.png'

const Content05BrowserComponent = ({...props}) : React.ReactElement => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles();

    return (
        <>
            {isWeb ? (
                <>
                    <div style={styles.screen_Web}>
                        <div style={styles.divFlex_Web}>
                            <div style={styles.divFlexColumn_Web}>
                                <span style={styles.titleTxt_Web}>
                                    지원 자격
                                </span>
                                <span style={styles.contentTxt_Web}>
                                    강아지/고양이를
                                </span>
                                <span style={styles.contentTxt_Web}>
                                    사랑하는 만 19세 이상 성인
                                </span>
                            </div>
                            <div style={{ ...styles.divFlexColumn_Web, marginRight: "30px" }}>
                                <img src={BackgroundImageWeb} style={styles.backgroundImage_Web} alt="이미지" />
                            </div>

                        </div>
                    </div>
                </>
            ) : (
                <>
                <div style={styles.screen_Mobile}>
                    <span style={styles.titleTxt_Mobile}>
                        지원 자격
                    </span>

                    <img src={BackgroundImageMobile} style={styles.backgroundImage_Mobile} alt="이미지" />
                </div>
                </>
            )}
        </>
    );
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    screen_Web: { backgroundColor: "white", display: "flex", flexDirection: "column", boxSizing: "border-box", paddingTop: responsivePaddingVertical(50, 90), paddingBottom: responsivePaddingVertical(43, 90), paddingLeft: responsivePaddingHorizontal(24, 88), paddingRight: responsivePaddingHorizontal(24, 88) },
    titleTxt_Web: { fontSize: responsiveFont(22, 40), fontWeight: 700, letterSpacing: -0.3, alignSelf: "flex-start", lineHeight: "140%", fontFamily: "Pretendard", marginBottom: "30px", paddingLeft: HorizontalPadding(24, 88)},
    contentTxt_Web: { fontSize: responsiveFont(20, 40), letterSpacing: -0.3, alignSelf: "flex-start", lineHeight: "150%", fontFamily: "Pretendard", color: "#1B1D1F", paddingLeft: HorizontalPadding(24, 88)},
    backgroundImage_Web: { width: responsiveImageSize(320, 800), height: responsiveImageSize(366, 716), marginTop: 44 },
    divFlex_Web: { display: "flex", flexDirection: "row", justifyContent: "space-between" },
    divFlexColumn_Web: { display: "flex", flexDirection: "column" },
    
    screen_Mobile: { width: "100%", minWidth: "320px", backgroundColor: "white", display: "flex", flexDirection: "column", alignItems: "center", boxSizing: "border-box", paddingTop: responsivePaddingVertical(50, 90), paddingBottom: responsivePaddingVertical(43, 90), paddingLeft: responsivePaddingHorizontal(24, 88), paddingRight: responsivePaddingHorizontal(24, 88) },
    titleTxt_Mobile: { fontSize: responsiveFont(22, 40), fontWeight: 700, letterSpacing: -0.3, alignSelf: "flex-start", lineHeight: "140%" },
    backgroundImage_Mobile: { width: responsiveImageSize(320, 800), height: responsiveImageSize(366, 716), marginTop: "40px" }
});

export default Content05BrowserComponent;